import { Builder } from '@builder.io/react';
import Text from './text';
import theme from '../../utilities/brandTheme';

Builder.registerComponent(Text, {
  name: 'Text',
  hideFromInsertMenu: true,
  inputs: [
    {
      name: 'text',
      type: 'html',
      required: true,
      autofocus: true,
      defaultValue: 'Enter some text...',
    },
    {
      name: 'textAlign',
      type: 'string',
      required: false,
      enum: [
        'start',
        'center',
        'end',
        'justify',
        'justify-all',
        'match-parent',
      ],
      defaultValue: 'start',
    },
    {
      name: 'textStyles',
      type: 'string',
      enum: theme.styles.textStyles,
      defaultValue: 'default',
    },
    {
      name: 'textColor',
      type: 'string',
      enum: theme.styles.textColors,
      defaultValue: 'default',
    },
    {
      name: 'textColorOverride',
      type: 'color',
      advanced: true,
      required: false,
    },
  ],
});


Builder.registerComponent(Text, {
  name: 'v2: Text',
  inputs: [
    {
      name: 'text',
      type: 'html',
      required: true,
      autofocus: true,
      defaultValue: 'Enter some text...',
    },
    {
      name: 'textAlign',
      type: 'string',
      required: false,
      enum: [
        'start',
        'center',
        'end',
        'justify',
        'justify-all',
        'match-parent',
      ],
      defaultValue: 'start',
    },
    {
      name: 'textStyles',
      type: 'string',
      enum: theme.styles.textStyles,
      defaultValue: 'default',
    },
    {
      name: 'textColor',
      type: 'string',
      enum: theme.styles.textColors,
      defaultValue: 'default',
    },
    {
      name: 'textColorOverride',
      type: 'color',
      advanced: true,
      required: false,
    },
  ],
});
